import {Component, ElementRef, Input, OnInit, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter, inject, DestroyRef} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {Principal} from 'src/app/models/principal/principal';
import { RouterSegments } from '../../../models/router-segments';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { translate } from '@jsverse/transloco';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';

@Component({
    selector: 'app-global-search',
    templateUrl: './global-search.component.html',
    styleUrls: ['./global-search.component.scss'],
    standalone: false
})
export class GlobalSearchComponent   implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  @Input() set selectedTenantId(selectedTenantId) {
    this.tenantId = selectedTenantId;
  }
  @Output() selectionChanged = new EventEmitter();
  tenant: string;
  principal: Principal;
  RouterSegments = RouterSegments;
  searchOptions = [];
  selected: any;
  searchPlaceholder: any;
  tenantId: any;
  blueprintList: any;
  solutionList: any;
  instanceList: any;
  searchText: any;
  searchValue = ''
  dataSource: any;
  showData: boolean;
  isAWS: boolean;
private destroyRef = inject(DestroyRef);
  constructor(private authService: AuthService, private router: Router, private sidenavService: SidenavService, private blueprintsService: BlueprintsService, private activatedRoute: ActivatedRoute,
     private solutionsService :SolutionsService, private instanceService: InstancesService, private tenantService: TenantService){
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedTenantId']) {
      this.clearInput();
      this.ngOnInit();
    }
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.principal = this.authService.principal;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.searchOptions = [
      {value: 'Service Definition' , selected: true, placeholder: 'Search for service definitions'},
      {value: 'Instance Name' , selected: false, placeholder: 'Search for instance name'},
      {value: 'Instance Suffix' , selected: false, placeholder: 'Search for instance suffix'},
      {value: 'Solutions' , selected: false, placeholder: 'Search for solutions'}
    ];
    this.selected = this.searchOptions[0].value;
    this.searchPlaceholder = this.searchOptions[0].placeholder;
    this.blueprintsService.getBlueprints()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      this.blueprintList = result;
    });
    // const solutionObj = {
    //   tenantId: this.tenantId
    // };
    this.solutionsService.getSolutions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.solutionList = data;
      });
      const obj = {
        tenantId: this.tenantId,
      };
      if (this.tenantId) {
        this.instanceService.getInstances(obj)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
          (data: any) => {
            const instanceObj = {
              size: data.total,
              tenantId: this.tenantId
            };
              this.instanceService.getInstances(instanceObj)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(instances => {
                  this.instanceList = instances;
          });
        });
      }      
  }

  getSelected(event): void {
    this.selected = event;
    if(this.selected === this.searchOptions[0].value) {
      this.searchPlaceholder = this.searchOptions[0].placeholder;
    } else if(this.selected === this.searchOptions[1].value) {
      this.searchPlaceholder = this.searchOptions[1].placeholder;
    } else if(this.selected === this.searchOptions[2].value) {
      this.searchPlaceholder = this.searchOptions[2].placeholder;
    }else {
      this.searchPlaceholder = this.searchOptions[3].placeholder;
    }
  } 

  searchBlueprint(event?): void {
    this.searchText = this.searchInput.nativeElement.value;
    let tableData: any;
    this.dataSource = [];
    if(this.selected === this.searchOptions[0].value) {
    tableData = this.blueprintList;
    if (this.searchText) {
      tableData?.filter(item => {
        if(item?.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())) {
          this.dataSource.push(item);
        }
      });
    } 
  } else if(this.selected === this.searchOptions[1].value) {
      tableData = this.instanceList;
      if (this.searchText) {
        tableData?.data?.filter(item => {
          if(item?.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())) {
            this.dataSource.push(item);
          }
        });
      }
    } else if(this.selected === this.searchOptions[2].value) {
      tableData = this.instanceList;
      if (this.searchText) {
        tableData?.data?.filter(item => {
          if(item?.randomSuffix?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())) {
            this.dataSource.push(item);
          }
        });
      }
    } else {
      tableData = this.solutionList;
      if (this.searchText) {
        tableData?.filter(item => {
          if(item?.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())) {
            this.dataSource.push(item);
          }
          });
        }
      }
      this.showData = this.dataSource.length > 0 ? true : false;
    }

  clearInput(): void {
    this.searchText = '';
    this.searchValue = ''
    this.showData = true;
    this.dataSource = [];
    if (this.searchInput?.nativeElement.value) {
      this.searchInput.nativeElement.value = '';
      const event = new KeyboardEvent('keyup',{bubbles:true, key: 'Backspace', code: 'Backspace'});
      this.searchInput.nativeElement.dispatchEvent(event);
    }
  }

  openUrl(data): void {
    if(data) {
      if(this.sidenavService.tenantSelectedMenu === undefined || this.sidenavService.tenantSelectedMenu === '' || this.sidenavService.tenantSelectedMenu === 'TENANT_LAYOUT.MENU.DASHBOARD') {
        if(this.selected === this.searchOptions[0].value) {
          this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.BLUEPRINTS, data.id])
        } else if(this.selected === this.searchOptions[1].value || this.selected === this.searchOptions[2].value) {
          this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
          this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.BLUEPRINTS, data.blueprintId, RouterSegments.ENVIRONMENT, data.id])
        } else {
          if(data.tenantId){
            localStorage.setItem('tenantViewSolutionName', data.name);
            this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.SOLUTION, data.id, 'versions'])
          } else {
            localStorage.setItem('sideMenu', this.sidenavService.selectedMenu);
            localStorage.setItem('breadcrumbItem', translate('LEFT_SIDE_NAV.SOLUTION_ONBOARDING'));
            localStorage.setItem('solutionItem', translate('LEFT_SIDE_NAV.SOLUTIONS'));
            localStorage.setItem('urlSolution', 'solutions');
            localStorage.setItem('solutionName', data.name);
            this.router.navigate(['/',this.authService.principal.provider, RouterSegments.SOLUTION, data.id, 'versions'])
          }
        }
        this.clearInput();
      }
      else {
        if(this.selected === this.searchOptions[0].value) {
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.BLUEPRINTS, data.id]))
        } else if(this.selected === this.searchOptions[1].value || this.selected === this.searchOptions[2].value) {
          this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.BLUEPRINTS, data.blueprintId, RouterSegments.ENVIRONMENT, data.id]))
        } else {
          if(data.tenantId) {
            localStorage.setItem('tenantViewSolutionName', data.name);
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['/',this.authService.principal.provider, 'tenant', data.tenantId,RouterSegments.SOLUTION, data.id, 'versions']))
          } else {
            localStorage.setItem('sideMenu', this.sidenavService.selectedMenu);
            localStorage.setItem('breadcrumbItem', translate('LEFT_SIDE_NAV.SOLUTION_ONBOARDING'));
            localStorage.setItem('solutionItem', translate('LEFT_SIDE_NAV.SOLUTIONS'));
            localStorage.setItem('urlSolution', 'solutions');
            localStorage.setItem('solutionName', data.name);
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['/',this.authService.principal.provider, RouterSegments.SOLUTION, data.id, 'versions']))
          }
          }
      }
    }
  }
}

